import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-video-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.scss'],
})
export class VideoPlayerComponent implements OnInit {
  @Input() videoUrl: any = '';
  constructor() { }

  ngOnInit() {}
  
removeAutoplayParams(url: string): string {
  const parsedUrl = new URL(url);
  parsedUrl.searchParams.delete('autoplay');
  return parsedUrl.toString();
}
}
